import React from 'react';

interface EventsMenuIconProps {
  size?: number;
  className?: string;
}

const EventsMenuIcon: React.FC<EventsMenuIconProps> = ({ size = 20, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.3333 10.8327V7.49935C18.3333 3.33268 16.6666 1.66602 12.5 1.66602H7.49996C3.33329 1.66602 1.66663 3.33268 1.66663 7.49935V12.4993C1.66663 16.666 3.33329 18.3327 7.49996 18.3327H10.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1084 12.0758L8.09174 9.50078C8.37507 9.13411 8.90007 9.06745 9.26674 9.35079L10.7918 10.5508C11.1584 10.8341 11.6834 10.7675 11.9667 10.4091L13.8918 7.92578"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4666 13.6582C16.5833 13.8915 16.875 14.1082 17.1333 14.1582L17.45 14.2082C18.4 14.3665 18.625 15.0665 17.9416 15.7582L17.65 16.0499C17.4583 16.2499 17.35 16.6332 17.4083 16.8999L17.45 17.0749C17.7083 18.2249 17.1 18.6665 16.1 18.0665L15.8833 17.9415C15.625 17.7915 15.2083 17.7915 14.95 17.9415L14.7333 18.0665C13.725 18.6749 13.1166 18.2249 13.3833 17.0749L13.425 16.8999C13.4833 16.6332 13.375 16.2499 13.1833 16.0499L12.8916 15.7582C12.2083 15.0665 12.4333 14.3665 13.3833 14.2082L13.7 14.1582C13.95 14.1165 14.25 13.8915 14.3666 13.6582L14.6 13.1832C15.05 12.2749 15.7833 12.2749 16.2333 13.1832L16.4666 13.6582Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EventsMenuIcon;
